import React, {useState} from 'react';

export default function DescriptionContent({content}) {
  const [isExpand, setIsExpand] = useState(false);

  return (
    <div className="classroom_text-content">
      <p className={isExpand ? 'expanded' : ''}>
        {content}
      </p>
      <button onClick={() => setIsExpand(c => !c)}>{isExpand ? 'Show less' : 'Show more'}</button>
    </div>
  )
}
